import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { EventSummary } from '@interfaces';
import { AccClassEventsViewerDialogDataService } from '../acc-class-events-viewer-dialog-data.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogDataService: AccClassEventsViewerDialogDataService, dialog: DialogService): GridSetup<EventSummary> {

	return {
		rowName: { singular: 'Event', plural: 'Events' },
		getRowKey: row => '' + row.eventId,
		stateKey: 'acc-class-events-grid',
		actions: getActions(dialogDataService, dialog),
		buttons: [],
		columns: getColumns(util),
	}
}
